<template>
  <v-container>
    <address-verification-modal
      v-model="modalOpen"
      :original-address="validationPayload"
      :suggested-address="suggestedAddress"
      @close-modal="modalOpen = false"
      @handle-address-selection="handleAddressSelection"
    />
    <property-details-form
      v-bind.sync="propertyDetailsData"
      :is-loading="isLoading"
      @cancel-edit-property="onCancelEdit"
      @save-property-details="validateAddress"
    />
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import PropertyDetailsForm from '@/components/properties/PropertyDetailsForm'
  import orgDetailsRouterMixin from '@/helpers/org-details-router-mixin'
  import validationAxios from '@/helpers/validation-client'
  import AddressVerificationModal from '@/components/properties/AddressVerificationModal'
  import isEqual from 'lodash.isequal'

  export default {
    name: 'AddPropertyDetails',
    components: { PropertyDetailsForm, AddressVerificationModal },
    mixins: [orgDetailsRouterMixin],
    data () {
      return {
        modalOpen: false,
        isLoading: false,
        addressValid: null,
        suggestedAddress: {},
        propertyDetailsData: {
          name: '',
          propertyType: '',
          area: null,
          maxOccupancy: null,
          street1: '',
          street2: '',
          city: '',
          region: '',
          postalcode: '',
          country: '',
          tags: [],
        },
      }
    },
    computed: {
      ...mapGetters({ currentSelectedOrg: 'Permissions/currentSelectedOrg' }),
      validationPayload () {
        return this.getAddress(this.propertyDetailsData)
      },
    },
    methods: {
      getAddress (propertyDetails) {
        return {
          street1: propertyDetails?.street1 ?? '',
          street2: propertyDetails?.street2 ?? '',
          city: propertyDetails?.city ?? '',
          region: propertyDetails?.region ?? '',
          postalcode: propertyDetails?.postalcode ?? '',
          country: propertyDetails?.country ?? '',
        }
      },
      clearPropertyDetailsForm () {
        this.propertyDetailsData = {
          name: '',
          propertyType: '',
          area: null,
          maxOccupancy: null,
          street1: '',
          street2: '',
          city: '',
          region: '',
          postalcode: '',
          country: 'US',
          tags: [],
        }
      },
      onCancelEdit () {
        this.clearPropertyDetailsForm()
        this.$router.push({ name: 'Properties' })
      },
      validateAddress () {
        validationAxios.post(`${this.$store.state.validatorURL}/api/v1/validation/address`, this.validationPayload)
          .then(res => {
            this.suggestedAddress = this.getAddress(res.data.address)
            if (!isEqual(this.validationPayload, this.suggestedAddress)) this.modalOpen = true
            else this.createNewProperty()
          })
      },
      handleAddressSelection (address) {
        for (const item in address) {
          this.propertyDetailsData[item] = address[item]
        }
        this.createNewProperty()
        this.modalOpen = false
      },
      createNewProperty () {
        const formPayload = this.propertyDetailsData
        const optional = ['area', 'maxOccupancy', 'street2']
        optional.forEach(key => {
          if (!formPayload[key]) delete formPayload[key]
        })
        if (formPayload.tags && !formPayload.tags.length) formPayload.tags = null
        const payload = {
          organization: {
            id: Number.parseInt(this.currentSelectedOrg.id),
          },
          ...formPayload,
        }
        this.isLoading = true
        this.$store.dispatch('Properties/createProperty', payload)
          .then(() => this.$store.dispatch('Permissions/fetchUserPermissions'))
          .finally(() => { this.isLoading = false })
      },
    },
  }
</script>
